import { ADD_NAMESPACE, NAVIGATION } from '../types';
import { error, success } from '../utils';

export let initialState = {
  addNamespace: {
    isLoading: false,
    isError: false,
  },
};

const reducer = (state, action) => {
  state = state || initialState;

  switch (action.type) {
    case ADD_NAMESPACE:
      return {
        ...state,
        addNamespace: {
          isLoading: true,
          isError: false,
        },
      };
    case success(ADD_NAMESPACE):
      return {
        ...state,
        addNamespace: {
          isLoading: false,
          isError: false,
        },
      };
    case error(ADD_NAMESPACE):
      return {
        ...state,
        addNamespace: {
          isLoading: false,
          isError: true,
        },
      };

    case NAVIGATION:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
